import { useCallback } from "react";

import { useHistory } from "react-router-dom";

function useUpdateSearchParams(): (
  updates: Record<string, string | undefined>,
) => void {
  const history = useHistory();

  return useCallback(
    (updates: Record<string, string | undefined>): void => {
      const params = new URLSearchParams(history.location.search);
      Object.entries(updates).forEach(([key, value]) => {
        if (value) params.set(key, value);
        else params.delete(key);
      });
      history.replace({ search: params.toString() });
    },
    [history],
  );
}

export default useUpdateSearchParams;
